// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","header":"Home_header__jgN9+","logo":"Home_logo__oiCAS","main":"Home_main__3ilkD","cardContainer":"Home_cardContainer__C9Pbd"};